/**
 * Shared list params for attachment file queries (newest first).
 */
export function attachmentsListParams(organizationId: string): {
	OrganizationId: string;
	OrderBy: { Fields: string[]; Descending: boolean };
} {
	return {
		OrganizationId: organizationId,
		OrderBy: { Fields: ["CreatedAt"], Descending: true },
	};
}
